export default __webpack_public_path__ + "static/media/user-check.a4ac3ac6.svg";